import { combineReducers } from 'redux';

import { authUserReducer } from './auth-user/auth-user.reducer';

export const rootReducer = combineReducers({
  auth_user: authUserReducer,
});
